import { Component, OnInit, Pipe, PipeTransform, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DPCustomerService } from './dp-customer.service';
import { DPCustomer } from './dp-customer';

import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import 'rxjs/Rx';

import { Overlay } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { DialogRef } from 'ngx-modialog';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import {UserDetailsService} from '../shared/user.details.service';

@Component({
    templateUrl: 'dp-customer.component.html',


})
export class DPCustomerComponent implements OnInit {
    customers: DPCustomer[];
    filteredCustomers: DPCustomer[];
    selectedCustomer: DPCustomer;
    addingCustomer = false;
    errorResponse: any;
    dialog: any;
    result: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    deleting = false;
    customerViewType = 'View All';

    //Permissions
    private isAccountManagerAdmin = this.userDetailsService.isHelpdeskAccountManager();
    private isAdmin = this.userDetailsService.isAdmin();

    constructor(
        private toasterService: ToasterService,
        private userDetailsService: UserDetailsService,

        private _service: NotificationsService,
        private router: Router,
        private customerService: DPCustomerService,
        public modal: Modal


    ) { }

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                // this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                // this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                // this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    getCustomers() {
        return this.customerService
            .getCustomers()
            .then(res => {
                if (res.customers) {
                    this.customers = res.customers;
                }
                this.clickViewType('View All');
            })
            .catch(error => {
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                const jsonErrorBody = JSON.parse(error._body);
                this.notificationContent = jsonErrorBody.error.message;
                this.createNotification();
            });
    }

    addCustomer() {
        this.addingCustomer = true;
        this.selectedCustomer = null;
    }

    deleteCustomer(customer: DPCustomer, event: any) {
        this.customerService
            .delete(customer)
            .then(res => {
                this.customers = this.customers.filter(u => u !== customer);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Customer : ' + customer.company_name + ' is deleted';
                this.createNotification();
                this.deleting = false;

                if (this.selectedCustomer === customer) { this.selectedCustomer = null; }
            })
            .catch(error => {
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                const jsonErrorBody = JSON.parse(error._body);
                this.notificationContent = jsonErrorBody.error.message;
                this.createNotification();
                this.deleting = false;

            });
    }

    ngOnInit() {
        this.getCustomers();
    }

    onSelect(customer: DPCustomer) {
        this.selectedCustomer = customer;
        this.addingCustomer = false;
    }

    gotoDetail(customer: DPCustomer) {
        this.router.navigate(['/demandportal/customer/customerdetail', customer.customer_id]);
    }

    selectCreateCustomer() {
        this.router.navigate(['/demandportal/customer/customercreate']);
    }

    gotoAccountList(customer: DPCustomer) {
        this.router.navigate(['/demandportal/customer/account', customer.customer_id]);
    }

    onClickActivationCustomer(customers: DPCustomer, event: any) {
        event.stopPropagation();
        const dialogMessage = customers.status === 1 ? 'You really want to deactivate this customer?' : 'You really want to activate this customer?';

        this.deleting = true;
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        this.processDialogActivation(customers, event, this.dialog);
    }
    private processDialogActivation(customers: DPCustomer, event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                if (customers.status === 1) {
                    customers.status = 0;
                } else {
                    customers.status = 1;
                }
                this.save(customers);
            }, () => {
                this.deleting = false;
                this.result = 'Rejected!';
            });
        });
    }

    save(customer: DPCustomer) {
        this.customerService
            .updateCustomer(customer)
            .then(res => {
                this.deleting = false;
                this.getCustomers();
            }
            )
            .catch(error => {
                if (customer.status === 1) {
                    customer.status = 0;
                }
                else {
                    customer.status = 1;
                }
                this.deleting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                const jsonErrorBody = JSON.parse(error._body);
                this.notificationContent = jsonErrorBody.error.message;
                this.createNotification();
            });
    }

    clickViewType(event: any) {
        if (this.customerViewType === 'View All') {
            this.filteredCustomers = this.customers;
            this.filteredCustomers.sort((leftSide, rightSide): number => {
                if (leftSide.status < rightSide.status) return 1;
                if (leftSide.status > rightSide.status) return -1;
                if (leftSide.status === rightSide.status && leftSide.customer_id > rightSide.customer_id) return -1;
                if (leftSide.status === rightSide.status && leftSide.customer_id < rightSide.customer_id) return 1;
                return 0;
            });
        } else if (this.customerViewType === 'View Active') {
            this.filteredCustomers = this.customers.filter(c => c.status === 1);
        } else {
            this.filteredCustomers = this.customers.filter(c => c.status === 0);
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-customer.component.ts